import { Typography } from '@mesa-labs/mesa-ui';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background-image: url("/assets/fullscreen-gradient-background.png");
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  overflow-y: auto;
  padding-top: 104px;
  width: 100%;
`;

export const SignInContainer = styled.div`
  background: transparent;
  padding: 32px;
  margin: 0px auto;
  max-width: 480px;
`;

export const HeaderContainer = styled.div`
  border-bottom: 1px solid #E1E4EA;
  margin-bottom: 32px;
  padding-bottom: 24px;  
`;

const OnboardingHeader = styled(Typography.H1)`
  color: #0E121B;
  font-family: ${(props) => props.theme.fonts.grotesk};
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  margin: 0px 0px 4px 0px;
  text-align: left;

  @media (min-width: ${(props) => props.theme.breakpoints.Tablet}) {
    margin: 0px 0px 8px 0px;
  }
`;

export const Header = styled(OnboardingHeader)`
  color: #0E121B;
  margin-bottom: 8px;
`;

export const SubHeader = styled(Typography.BodySmall)`
  color: #525866;
`;

function SignInLayout({ children }: { children: React.ReactNode }) {
  return (
    <Container>
      {children}
    </Container>
  );
}

export default SignInLayout;
